<template>
  <div v-loading="initLoading" class="body">
    <div v-show="doResult.list.length!=is_show_card" class="timerBox">
      <img class="backIcon" src="@/assets/back_black.png" alt="" @click="backAction">
      <p>{{ titleStr }}</p>
      <span v-if="allLength > 0 && !isDoWrong()" class="topCard" @click="answerSheet">答题卡</span>
    </div>
    <div v-show="is_show_card&&(doResult.list.length==is_show_card)" class="timerBox" @click="toDoPaper">
      <img class="backIcon" src="@/assets/back_black.png">
      <p>答题卡</p>
      <!-- 占位 -->
      <img class="backIcon" style="visibility: hidden;" src="@/assets/back_black.png">
    </div>
    <div class="main">
      <slider v-if="doResult.list.length" ref="mySwiper" :options="swiperOption" @slide="slide">
        <slideritem v-for="(item, key) in doResult.list" :key="key" :class="($route.query.source_type == 6 || $route.query.source_type == 7 || $route.query.source_type == 11 || $route.query.source_type == 12) ? 'swiper-no-swiping' : '' ">
          <div class="topic_item">
            <div class="item">
              <div class="itemTop">
                <p class="itemTitle">
                  <span class="titleBox">
                    <span class="redSpan">
                      <!-- <span class="left_bor"></span> -->
                      {{ item.type_name }}
                      <!-- <span class="right_bor"></span> -->
                      <span class="itemId">试题ID{{ item.id }}</span>
                    </span>
                    <div class="titleBoxRight">
                      <img v-if="source_type == 12" class="delete" src="https://newoss.zhulong.com/forum/202211/30/16/1669797420886888.png" alt="" @click="clearTopic(item)">
                      <span class="counts"><span style="color:#ee2e2e;">{{ doResult.list.indexOf(item) + 1 }}</span>/{{ allLength }}</span>
                    </div>
                  </span>
                  <!-- {{ testIndex + 1 }}. -->
                </p>
                <p class="itemTitle2">
                  <viewer ref="viewer" :index="3" class="viewer-style" @inited="inited">
                    <span class="name" v-html="item.exercise_name"> </span>
                  </viewer>
                </p>
              </div>
              <!-- 选项 -->
              <div class="itemOpiton">
                <van-radio-group v-if="item.exercise_type == 1 || item.exercise_type == 3" v-model="item.select" :disabled="item.isAnalysis" :label-disabled="item.isAnalysis">
                  <template v-if="item.exercise_type == 3 && checkIsNewSubjective(item)">
                    <div v-if="!item.isAnalysis">
                      <AiAnalysis :config="aiConfig" :old-answer="item.user_answer" :answer-type="item.answer_type" :disabled="item.isAnalysis" @success="(val) => analysisSuccess(val,item)" @error="(t,e)=>analysisError(t,e,item)" />
                    </div>
                  </template>
                  <template v-else>
                    <van-radio v-for="(ele,index) in item.option" :key="index" :name="ele.mark" checked-color="#ee2e2e" @click="radioClick(item)">
                      <template #icon="props">
                        <!-- <img class="solution_icon" :src="props.checked ? (item.isAnalysis ? green_icon : red_icon) : normal_icon"> -->
                        <img class="solution_icon" :src="!item.icant&&props.checked ? red_icon : normal_icon">
                        <span class="check" :class="!item.icant&&props.checked ?'checkActive':''">{{ ele.mark }}</span>
                      </template>
                      <div class="oneOption" style="display: flex;align-items: center;">
                        <div :class="item.isAnalysis?(ele.is_true==1?'green_bg':''):''" style="margin-left: 10px;" v-html="ele.detail"></div>
                      </div>
                    </van-radio>
                  </template>
                </van-radio-group>
                <van-checkbox-group v-else v-model="item.select" :disabled="item.isAnalysis" :label-disabled="item.isAnalysis">
                  <template v-for="(ele, index) in item.option">
                    <van-checkbox :key="index" :name="ele.mark" checked-color="#ee2e2e" @click="radioClick(item)">
                      <template #icon="props">
                        <img class="solution_icon" :src="!item.icant&&props.checked ? (item.isAnalysis ? red_icon2 : red_icon2) : normal_icon2">
                        <span class="check" :class="!item.icant&&props.checked ?'checkActive':''">{{ ele.mark }}</span>
                      </template>
                      <div class="oneOption" style="display: flex;align-items: center;">
                        <div :class="item.isAnalysis?(ele.is_true==1?'green_bg':''):''" style="margin-left: 10px;" v-html="ele.detail"></div>
                      </div>
                    </van-checkbox>
                  </template>
                </van-checkbox-group>
              </div>
              <!-- 此题我不会 -->
              <div v-if="answer_type == 1 && !item.isAnalysis" class="icant">
                <span @click="iCantDoIt(item)">此题我不会</span>
              </div>
              <!-- 解析 -->
              <div v-if="answer_type == 1 && item.isAnalysis" class="div_answer">
                <div class="vLine"></div>
                <div class="answerBox">
                  <div class="answerBoxTop">
                    <p v-if="checkIsNewSubjective(item)" class="answer_title">答案</p>
                    <p v-else class="answer_title">{{ item.correct == 1?'答案正确':'答案错误' }}</p>
                    <p v-show="true" class="answer_jc" @click="toCorrect(item)">纠错有奖 <img src="https://newoss.zhulong.com/forum/202407/08/31/172431okx3irir8qs3rjwv.png" alt=""> </p>
                  </div>
                  <div v-if="checkIsNewSubjective(item)" class="new_answer_res">
                    <div class="new_answer " :class="item.correct == 1 ?'right_answer1':'error_answer1'">
                      <span>你的答案：</span>
                      <div :class="item.correct == 1 ?'green_font':'red_font'">
                        <p v-html="item.select_status == 2 ? '我不会' :item.user_answer"></p>
                        <p>得分：{{ item.score || 0 }}</p>
                      </div>
                    </div>
                    <div class="new_answer mgtop">
                      <span>标准答案：</span>
                      <p v-html="item.true_answer"></p>
                    </div>
                  </div>
                  <div v-else class="answer_res">
                    <!-- 未作答 -->
                    <p v-if="item.userSelect == ''" class="p_answer" :class="item.userSelect == '' ?'empty_answer':''">
                      <span>你的答案</span>
                      <span class="red_font">{{ item.userSelect == '' ? '我不会' : item.userSelect }}</span>
                      <!-- <span v-if="item.correct == 1" class="span_tag_is_true green">回答正确</span> -->
                      <!-- <span v-else class="span_tag_is_true red">回答错误</span> -->
                    </p>
                    <p v-if="item.userSelect != ''" class="p_answer" :class="item.correct == 1 ?'right_answer':'error_answer'">
                      <span>你的答案</span>
                      <span :class="item.correct == 1 ?'green_font':'red_font'">{{ item.userSelect }}</span>
                    </p>
                    <p class="p_answer">
                      <span>正确答案</span>
                      <span class="green_font">{{ item.answer }}</span>
                    </p>
                  </div>

                </div>
                <div class="vLine"></div>
                <div class="analysisBox">
                  <p class="jx_title">试题解析</p>
                  <p v-if="is_play" class="jx_content" v-html="item.answer_analysis"></p>
                  <div v-if="!is_play" class="noBuyBox">
                    <p class="buyInfo">只有付费用户，才能查看文字解析和视频解析，请点击下方按钮购买</p>
                    <span class="buyBtn" @click="buyBtnAction">立即购买</span>
                  </div>
                </div>
                <!-- 视频解析 -->
                <div v-if="item.is_video_analysis" class="videoBtnBox">
                  <div class="playItems">
                    <img src="@/assets/can_play_icon.png" alt="" @click="videoAnalysis(item)">
                    <span @click="videoAnalysis(item)">查看视频解析</span>
                  </div>
                  <div v-if="!is_play" class="maskV"></div>
                </div>
                <!-- 帮友讨论 -->
                <!-- <template v-if="answer_type == 1 && item.isAnalysis && (lesson_id && lesson_id.length > 0)">
                  <div class="vLine"></div>
                  <div class="analysisBox">
                    <p class="jx_title">帮友讨论</p>
                    <div class="topicsBox">
                      <div class="inputBox">
                        <van-field v-model="item.topicInputText" class="input_" placeholder="请输入" />
                        <span class="sendBtn" @click="sendTopic(item)">发送</span>
                      </div>
                      <div v-if="item.topicList && item.topicList.length > 0" class="topicLists">
                        <div v-for="(topic,tindx) in item.topicList" :key="tindx" class="topicItem">
                          <div class="mainItem">
                            <div class="imgBox">
                              <img class="avatar" :src="topic.avatar" alt="">
                            </div>
                            <div class="topicInfo">
                              <p class="topInfo"><span>{{ topic.username }}</span><span class="time1">{{ topic.create_time }}</span></p>
                              <p class="content" v-html="topic.content"></p>
                            </div>
                          </div>
                          <div v-if="topic.list && topic.list.length > 0" class="subBox">
                            <div v-for="(sub,sindex) in topic.list" :key="sindex" class="subItem">
                              <div class="imgBox">
                                <img class="avatar" :src="sub.avatar" alt="">
                              </div>
                              <div class="topicInfo">
                                <p class="topInfo"><span class="redT">{{ sub.username }}</span><span class="grayT">回复{{ sub.to_username }}</span></p>
                                <p class="content" v-html="sub.content"></p>
                                <p class="time2">{{ sub.create_time }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template> -->
              </div>
            </div>
          </div>
        </slideritem>
        <slideritem>
          <answerCard v-if="is_show_card==doResult.list.length" :son-module="sonModule" @activePage="goActive" @clearTimer="clearDownTimer"></answerCard>
        </slideritem>
      </slider>
      <!-- 底部按钮 -->
      <div v-if="doResult.list.length" v-show="doResult.list.length!=is_show_card" class="footer">
        <!-- <p class="itemId">【试题ID{{ item.id }}】</p> -->
        <div v-show="answer_type === 1">
          <!-- 随堂练习，对答案 -->
          <div class="menuBg1">
            <span v-show="testIndex === 0" class="normaleBtn btnGray">
              <!-- 上一题 -->
              <img class="prev_img" src="https://newoss.zhulong.com/book/202211/14/32/171032rfajcu3nc8t4ygik.png" alt="">
              <span class="prev_text">上一题</span>
            </span>
            <!--  -->
            <span v-show="testIndex != 0" slot="button-prev" class="normaleBtn review-swiper-button-prev" @click="preItem">
              <img class="prev_img" src="https://newoss.zhulong.com/book/202211/14/46/171446qcvysog27yis0o7z.png" alt="">
              <span class="prev_text">上一题</span>
              <!-- 上一题 -->
            </span>
            <!-- 对答案 灰色 -->
            <span v-if="doResult.list[testIndex].checkBtnState || doResult.list[testIndex].isAnalysis" class="grayLineBtn">
              <img class="answer_img" src="https://newoss.zhulong.com/book/202211/14/1/175101kvyp5qkkwp2ytw1f.png" alt="">
              <span>答案</span>
              <!-- 对答案 -->
            </span>
            <!-- 对答案 红色 -->
            <span v-else class="redBgBtn" @click="checkTheAnswer(doResult.list[testIndex], false)">
              <!-- 对答案 -->
              <img class="answer_img" src="https://newoss.zhulong.com/book/202211/15/23/16172312zrd8jz2ab6ulmr.png" alt="">
              <span>答案</span>
            </span>
            <!-- 下一题：错题 - 默认灰色、对完答案红色 最后一题没有下一题、其他的 - 最后一题是交卷 -->
            <div v-show="isDoWrong()" class="outerBox">
              <!-- 错题 -->
              <!--  -->
              <span v-show="testIndex !== (allLength-1) && doResult.list[testIndex].isAnalysis" slot="button-next" class="redLineBtn review-swiper-button-next" @click="nextItem">
                <span class="next_text">下一题</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
                <!-- 下一题 -->
              </span>
              <span v-show="testIndex !== (allLength-1) && !doResult.list[testIndex].isAnalysis" class="grayLineBtn1">
                <span class="next_text">下一题</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/15/13/100813r7ei9l9sqis27tmv.png" alt="">
                <!-- 下一题 -->
              </span>
              <span v-if="testIndex == (allLength-1) && doResult.list[testIndex].isAnalysis" class="redLineBtn" @click="answerSheet">
                <span class="next_text">答题卡</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
                <!-- 下一题 -->
              </span>
              <span v-if="testIndex == (allLength-1) && !doResult.list[testIndex].isAnalysis" class="grayLineBtn1">
                <span class="next_text">答题卡</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/15/13/100813r7ei9l9sqis27tmv.png" alt="">
                <!-- 下一题 -->
              </span>
            </div>
            <div v-show="!isDoWrong()" class="outerBox">
              <!-- 随堂练习 -->
              <span v-show="testIndex !== (allLength-1)" slot="button-next" class="redLineBtn review-swiper-button-next" @click="nextItem">
                <span class="next_text">下一题</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
                <!-- 下一题 -->
              </span>
              <span v-if="testIndex === (allLength-1)" class="redLineBtn" @click="answerSheet(true)">
                <span class="next_text">答题卡</span>
                <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
              </span>
            </div>
          </div>
        </div>
        <div v-show="answer_type != 1">
          <!-- 其他类型，无对答案 -->
          <div class="menuBg2">
            <span v-show="testIndex === 0" class="normaleBtn btnGray">
              <img class="prev_img" src="https://newoss.zhulong.com/book/202211/14/32/171032rfajcu3nc8t4ygik.png" alt="">
              <span class="prev_text">上一题</span>
            </span>
            <!--   -->
            <span v-show="testIndex !== 0" slot="button-prev" class="normaleBtn review-swiper-button-prev" @click="preItem">
              <img class="prev_img" src="https://newoss.zhulong.com/book/202211/14/46/171446qcvysog27yis0o7z.png" alt="">
              <span class="prev_text">上一题</span>
            </span>
            <span v-show="testIndex === (allLength-1)" class="normaleBtn" @click="answerSheet">
              <!-- btnGray -->
              <!-- 答题卡  -->
              <span class="next_text">答题卡</span>
              <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
            </span>
            <!--  -->
            <span v-show="testIndex != (allLength-1)" class="normaleBtn review-swiper-button-next" @click="nextItem">
              <!-- 下一题 -->
              <span class="next_text">下一题</span>
              <img class="next_img" src="https://newoss.zhulong.com/book/202211/14/2/1717025a5u4msyf53ys3ze.png" alt="">
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 遮罩等待 -->
    <loadingView v-show="showLoading" />
    <!-- 播放视频 -->
    <playVideoView :show_play_view="playVideoPop" @closePlay="closePlayVideo"></playVideoView>
    <!-- 购买弹窗 -->
    <!-- <buyAlert :showalert="showBuyPop" :catid="category_id" @closed="closeBuyPop"></buyAlert> -->
    <!-- 销售策略弹窗 -->
    <strategyView :pop-strategy="showStrategyView" @setShowStrategy="setShowStrategy" @colseStrategy="colseStrategyView" @buyStategy="buyNow"></strategyView>
    <!-- 纠错弹窗  -->
    <van-popup v-model="showCorrect" :style="{ width: '100%', backgroundColor: 'transparent' }">
      <div class="input_body">
        <div class="input_box">
          <p class="t_title">错题反馈</p>
          <p class="title_tip">反馈错题有效，奖励1000筑龙币！</p>
          <van-field v-model="inputCorrect" class="input_field" type="textarea" placeholder="请输入问题描述" />
          <div class="bot_menu">
            <span @click="commitCorrect">提交</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { slider, slideritem } from 'vue-concise-slider'
import tool from '@/utils/tools.js'
import { Dialog } from 'vant'
import playVideoView from '@/views/evaluation/playVideoView.vue'
import WechatState from '@/utils/isWechatState.js'
import answerCard from './answerSheet_new.vue'
import { startExercise, checkAnswer, submitAnswer, proceedExercise, delErrToCorrectExercise, errorFeedback } from '@/api/zkbproEdu.js'
import { QaAll, saveQa } from '@/api/zkbproQA.js'
import Cookies from 'js-cookie'
import loadingView from '@/components/loadingView.vue'
import strategyView from '@/components/strategyView.vue'
import { getAiEnToken } from '@/api/chatGPT'

export default {
  components: {
    slider,
    slideritem,
    answerCard,
    playVideoView,
    strategyView,
    loadingView
  },
  data() {
    const that = this
    return {
      red_icon:
        // 'https://newoss.zhulong.com/forum/202107/05/18/1625479440992030.png',
        'https://newoss.zhulong.com/book/202211/14/53/15525395trzfyc9ajedwsi.png',
      green_icon:
        // 'https://newoss.zhulong.com/forum/202107/05/17/1625478425431165.png',
        'https://newoss.zhulong.com/book/202211/14/6/155406acxnpyncyyjbemvx.png',
      normal_icon:
        // 'https://newoss.zhulong.com/forum/202107/05/17/1625478759670000.png',
        'https://newoss.zhulong.com/book/202211/14/40/1613401ww5dnoeqhqofazc.png',
      red_icon2:
        'https://newoss.zhulong.com/book/202211/14/21/170121bujlbsnhc4lpcxtr.png',
      green_icon2:
        'https://newoss.zhulong.com/book/202211/14/49/170049ztycl9y8hb5jppwq.png',
      normal_icon2:
        'https://newoss.zhulong.com/book/202211/14/7/170007o05yi957n6hp6lk2.png',
      exam_name: '评测',
      titleStr: '',
      isWechat: WechatState.isWechat,
      isWechatMp: WechatState.isWechatMiniprogram,
      // 新版参数
      lesson_id: this.$route.query.lesson_id || '',
      class_id: this.$route.query.class_id || '',
      schedule_id: this.$route.query.schedule_id || '',
      source_id: this.$route.query.source_id,
      source_type: this.$route.query.source_type,
      // 继续做题
      is_retain: this.$route.query.is_retain || 0,
      // 评测类型：根据类型判断时间、解析等布局
      answer_type: '',
      answer_id: this.$route.query.answer_id || '',
      // 分类id
      category_id: Cookies.get('pro_category_id') || '',
      category_name: decodeURIComponent(Cookies.get('pro_category_name') || ''),
      showBuyPop: false,
      // 倒计时时间
      allTime: 0,
      time: 0,
      time_limit: 0,
      countdownTimer: null,
      // 试题数组
      doResult: {
        list: []
      },
      allLength: 0,
      testIndex: 0,
      playVideoPop: false,
      is_play: 0,
      // 是否有销售策略
      hasStrategy: false,
      // 展示销售策略弹窗
      showStrategyView: false,
      // 加载等待
      showLoading: false,
      initLoading: true,
      sonModule: {}, // 父组件向子组件传的值
      currentIndex: Number(this.$route.query.page) || 0,
      is_show_card: '', // 用于判断答题卡页面是否显示底部
      showCard: true, // 答题卡悬浮窗
      swiperObj: {
        swiperArr: []
      },
      newObj: {}, // 数据处理为每十条一组
      swiperOption: {
        currentPage: Number(that.$route.query.page) || 0, // 当前页码
        timingFunction: 'ease',
        // thresholdDistance: 500, // 滑动判定距离
        // thresholdTime: 100, // 滑动判定时间
        loop: false, // 循环滚动
        direction: 'horizontal', // 方向设置，垂直滚动
        pagination: false, // 底部小圆点是否隐藏
        freeze: that.$route.query.source_type == 6 || that.$route.query.source_type == 7 || that.$route.query.source_type == 11 || that.$route.query.source_type == 12// 禁止滑动
        // infinite: 1, // 无限滚动前后遍历数
        // slidesToScroll: 1, // 每次滑动项数
      },
      // 纠错
      showCorrect: false,
      correctId: '',
      inputCorrect: '',
      // ai请求的配置信息
      aiConfig: {
        appkey: '',
        token: ''
      }
    }
  },
  created() {
    // 获取配置config
    this.getAiEnToken()
    // 获取数据 --> 看是否有上次做题
    // 先读取 本地数据
    const obj = sessionStorage.getItem('paperLists')
    if (obj) {
      const result = JSON.parse(obj)
      const pageStr = this.$route.query.page || '0'
      console.log('旧值', result, pageStr)
      this.unitControlData(result, false, parseInt(pageStr))
    } else {
      // 判断 is_retain = 1 继续做题
      if (this.is_retain == 1) {
        this.getLastPaperDatas()
      } else {
        // 新获取题
        this.getPageInit()
      }
    }
  },
  methods: {
    slide(data) {
      // console.log(data)
      this.is_show_card = data.currentPage
      this.testIndex = data.currentPage
      if (this.testIndex == this.doResult.list.length) {
        this.saveData()
        this.testIndex = this.doResult.list.length - 1
      }
      // this.scrollToTop(data.currentPage)
    },
    toDoPaper() {
      this.$refs.mySwiper.$emit('slidePre')
    },
    inited(viewer) {
      this.$viewer = viewer
      this.$viewer.index = this.activeIndex
      // 不要他的按钮
      // this.$viewer.options.button = false
      // 不要他的底部缩略图
      // this.$viewer.options.navbar = false
      // 不要他的底部标题
      this.$viewer.options.title = false
      // 不要他的底部工具栏
      this.$viewer.options.toolbar = false
      // this.show()
    },
    goActive(val) {
      this.is_show_card = val
      this.currentIndex = val
      this.$refs.mySwiper.$emit('slideTo', val)
    },
    // 轮播图滚动到顶部
    scrollToTop(realIndex) {
      const swiperDoms = document.querySelectorAll('.slider-container .slider-wrapper .slider-item')
      // console.log(swiperDoms)
      if (swiperDoms) {
        swiperDoms.forEach((item, index) => {
          if (index == realIndex) {
            setTimeout(() => {
              if (item.querySelector('.topic_item')) {
                item.querySelector('.topic_item').scrollTop = 0
              }
            }, 300)
          }
        })
      }
    },
    // 获取上次做题
    getLastPaperDatas() {
      const post = {
        answer_id: this.answer_id
      }
      proceedExercise(post).then(res => {
        console.log(res, '========')
        const errNo = res.errNo
        const result = res.result || {}
        const list = result.list || []
        const next_idx = result.next_exercise_num || 0
        if (errNo === 0 && list.length > 0 && next_idx > 0) {
          // 放上继续
          this.goOnUseLastData(result)
        } else {
          // 重新获取新题
          this.getPageInit()
        }
      }).catch(() => {
        // 重新获取新题
        this.getPageInit()
      })
    },
    // 继续上次
    goOnUseLastData(result) {
      result.list.forEach(e => {
        // 帮友讨论
        e.topicInputText = ''
        e.topicList = []
        e.checkBtnState = true
        e.isAnalysis = false
        e.icant = false
        const process = e.process || 0
        if (process == 1) {
          // 做过
          if (result.answer_type == 1) {
            if (this.checkIsNewSubjective(e) && e.exercise_type == 3) {
              e.isAnalysis = true
            } else {
              e.userSelect = e.select.join(',')
              e.answer = e.right.join(',')
              if (e.exercise_type == 2) {
                // e.select = e.right
              } else {
                e.select = e.select[0] || ''
              }
              e.isAnalysis = true
            }
          } else {
            if (this.checkIsNewSubjective(e) && e.exercise_type == 3) {
              // e.user_answer
            } else {
              // 因为字段名冲突，临时转换下
              const old_select = e.select
              if (e.exercise_type == 2) {
                e.select = old_select
              } else {
                e.select = old_select[0] || ''
              }
            }
          }
        } else {
          // 未做过 -> 按未选处理
          if (e.exercise_type == 2) {
            e.select = []
          } else {
            e.select = ''
          }
          e.select_status = 0
        }
      })
      this.unitControlData(result, true, 0)
    },
    // 获取做题数据方法
    getPageInit() {
      this.getPaperDatas()
    },
    // 获取数据
    getPaperDatas() {
      const post = {
        source_id: this.source_id,
        source_type: this.source_type,
        lesson_id: this.lesson_id,
        schedule_id: this.schedule_id,
        class_id: this.class_id,
        source: 'pro'
      }
      startExercise(post).then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo === 0) {
          const result = res.result || {}
          const list = result.list || []
          if (list.length > 0) {
            result.list.forEach(e => {
              // 帮友讨论
              e.topicInputText = ''
              e.topicList = []
              e.checkBtnState = true
              e.isAnalysis = false
              e.icant = false
              if (e.exercise_type == 2) {
                e.select = []
              } else {
                e.select = ''
              }
              e.select_status = 0
            })
            this.unitControlData(result, false, 0)
          } else {
            this.$toast('当前测试没有数据')
          }
        } else if (errNo == 2001) {
          if (this.$route.query.pkType == 1) {
            const url = '/pages/index/index'
            this.$wx.miniProgram.navigateTo({
              url: url
            })
          } else {
            this.showLogin()
          }
        } else {
          this.$toast(res.msg)
        }
        this.initLoading = false
      })
    },
    // 统一处理数据：result：数据、isLast：继续上次、clickPage：点击页码
    unitControlData(result, isLast, clickPage) {
      this.answer_id = result.answer_id
      this.answer_type = result.answer_type || ''
      this.exam_name = result.answer_name
      this.doResult = result
      this.allLength = result.list.length
      this.is_play = result.answer_free || 0
      // 如果pk榜做题，免费
      console.log('all length = ', this.allLength)
      console.log('isLast = ', isLast)
      // 取默认第几个
      if (isLast) {
        let next_num = result.next_exercise_num || 0
        if (next_num > this.allLength) {
          next_num = this.allLength
        }
        const lastIndx = Math.max(0, next_num - 1)
        this.testIndex = lastIndx
        console.log('继续上次 = ', lastIndx)
        this.$nextTick(() => {
          if (this.$refs.mySwiper) {
            this.$refs.mySwiper.$emit('slideTo', this.testIndex)
          }
        })
      } else {
        if (clickPage > 0 && clickPage < this.allLength) {
          this.testIndex = clickPage
          // this.$refs.mySwiper.$emit('slideTo', this.testIndex)
        }
      }

      // 判断定时器
      // this.time_limit = result.time_limit
      const time = result.answer_duration
      if (this.answer_type == 1) {
        this.titleStr = this.exam_name
      } else {
        if (time > 0) {
          this.time = time * 60
          this.allTime = time
          clearInterval(this.countdownTimer)
          this.countdownTimer = setInterval(this.timerFunction, 1000)
        } else {
          this.titleStr = this.exam_name
        }
      }
      this.initLoading = false
    },
    // 倒计时方法
    timerFunction() {
      if (this.time >= 0) {
        var hours = Math.floor(this.time / 3600)
        var minutes = Math.floor((this.time % 3600) / 60)
        var seconds = Math.floor(((this.time % 3600) % 60))
        var str = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
        this.titleStr = str
        this.time -= 1
      } else {
        clearInterval(this.countdownTimer)
        Dialog.alert({
          title: '结束练习',
          message: '答题时间已到,系统已自动提交答卷',
          confirmButtonText: '关闭'
        })
          .then(() => {
            // on confirm
            this.submitAll()
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 选择
    radioClick(val) {
      if (val.select_status == 0) {
        var str = val.exercise_type == 2 ? val.select.join(',') : val.select.toString()
        if (str.length > 0) {
          val.checkBtnState = false
        } else {
          val.checkBtnState = true
        }
        // 避免选了答案却不对答案
        if (this.answer_type == 1) {
          val.userSelect = val.select
        }
      }
    },
    // 上一题
    preItem() {
      if (this.testIndex > 0) {
        this.testIndex -= 1
      } else {
        this.testIndex = 0
      }
      if (this.testIndex == this.doResult.list.length) {
        this.testIndex = this.doResult.list.length - 1
      }
      this.$refs.mySwiper.$emit('slidePre')
    },
    // 下一题
    nextItem(status) {
      if (!this.isDoWrong()) {
        const item = this.doResult.list[this.testIndex]
        this.checkTheAnswer2(item)
        if (this.testIndex < (this.doResult.list.length - 1)) {
          this.testIndex += 1
        }
      } else {
        if (this.doResult.list[this.testIndex].isAnalysis) {
          if (this.testIndex < (this.doResult.list.length - 1)) {
            this.testIndex += 1
          }
        }
      }
      if (this.testIndex == this.doResult.list.length) {
        this.testIndex = this.doResult.list.length - 1
      }
      this.$refs.mySwiper.$emit('slideNext')
    },
    // 此题我不会
    iCantDoIt(item) {
      item.icant = true
      this.checkTheAnswer(item, true)
    },
    // 对答案，answer_type!=1的对答案
    checkTheAnswer2(item) {
      console.log(item, 'xiayitie')
      var str = item.exercise_type == 2 ? item.select.join(',') : item.select.toString()
      // 新主观题处理参数
      const is_new = this.checkIsNewSubjective(item)
      if (is_new) {
        str = item.user_answer || ''
      }
      var new_select = item.old_select || item.select_status == 1 || item.select_status == 2 ? item.old_select : str
      item.select_status = item.select_status != 0 ? item.select_status : new_select ? 3 : 0
      var info = {
        answer_id: this.answer_id,
        exercise_id: item.id,
        select: is_new ? '' : new_select,
        user_answer: is_new ? str : '',
        select_status: item.select_status
      }
      // if (this.testIndex >= this.allLength - 1) {
      //   info.final = 1
      // }
      this.postCheckInfo(info, item, false, false)
    },
    // 对答案 此题我不会 走此方法：，answer_type=1的对答案、icant：true 此题我不会
    checkTheAnswer(item, icant) {
      if (item.isAnalysis) {
        // 对过了
        console.log('对过了')
        return
      }
      // 此处就开始加载
      this.showLoading = true

      // 答案
      var str = item.exercise_type == 2 ? item.select.join(',') : item.select.toString()
      // 新主观题处理参数
      const is_new = this.checkIsNewSubjective(item)
      if (is_new) {
        str = item.user_answer || ''
      }
      // 此题我不会
      if (icant) {
        str = ''
        item.checkBtnState = false
      }
      item.select_status = str ? 3 : icant ? 2 : 0
      var info = {
        answer_id: this.answer_id,
        exercise_id: item.id,
        select: is_new ? '' : str,
        user_answer: is_new ? str : '',
        select_status: item.select_status
      }
      // if (this.testIndex >= this.allLength - 1) {
      //   info.final = 1
      // }
      this.postCheckInfo(info, item, true, true)
    },
    //  获取是否做对、解析  topic：true 请求讨论
    postCheckInfo(info, item, doOther, topic) {
      console.log('isAnalysis = ', item.isAnalysis)
      console.log('icant = ', item.icant)
      console.log('select = ', item.select)
      console.log('userSelect = ', item.userSelect)
      if (item.isAnalysis) {
        return
      }
      info.lesson_id = this.lesson_id
      checkAnswer(info).then((res) => {
        console.log(res)
        this.showLoading = false
        if (doOther) {
          if (res.errNo === 0) {
            // 标记解析
            const result = res.result
            item.answer = result.right ? result.right.join(',') : ''
            item.answer_analysis = result.answer_analysis
            item.correct = result.correct
            item.score = result.score
            // if (item.exercise_type == 2) {
            //   item.select = result.right
            // } else {
            //   item.select = result.right[0] || ''
            // }
            item.old_select = info.select
            item.userSelect = result.select ? result.select.join(',') : ''
            item.url = result.url
            item.is_video_analysis = result.is_video_analysis
            item.isAnalysis = true
            // // 奖励积分
            // const showScore = result.added
            // if (showScore) {
            //   this.$toast({
            //     message: '恭喜答对，获得10币',
            //     icon: require('@/assets/do_get_coin.png')
            //   })
            // }
            // 错题的最后一道
            if (this.isDoWrong() && this.testIndex === (this.allLength - 1)) {
              this.$toast('该知识点错题已做完')
            }
            // 判断是否请求讨论
            if (topic && this.lesson_id) {
              this.getTopicDatas(item)
            }
          } else {
            this.$toast(res.msg)
          }
        }
      }).catch((err) => {
        this.showLoading = false
        console.log(err)
      })
    },
    // 答题卡
    answerSheet(is_next = false) { // is_next 判断是否是右下角最后一题时点击的答题卡按钮
      console.log(is_next)
      if (is_next) {
        this.nextItem()
      }
      this.saveData()
      this.$refs.mySwiper.$emit('slideTo', this.doResult.list.length)
    },
    saveData() {
      // 整理数据存储
      const remain = Math.floor(this.time / 60)
      this.doResult.duration = remain
      sessionStorage.setItem('paperLists', JSON.stringify(this.doResult))
      // 整理参数
      const query = this.$route.query
      query.time = this.allTime - remain
      query.answer_id = this.answer_id
      query.index = this.testIndex
      // console.log(query)
      // 跳转
      this.sonModule = query
    },
    subAlert() {
      var noDoCount = 0
      const arr1 = this.doResult.list
      arr1.forEach(e => {
        if (this.answer_type == 1) {
          var str = ''
          if (e.exercise_type == 3 && this.checkIsNewSubjective(e)) {
            str = e.user_answer || ''
          } else {
            if (e.userSelect) {
              const sel = e.userSelect
              if (typeof (sel) === 'string') {
                const selStr = sel.toString()
                if (selStr.indexOf(',' != -1)) {
                  str = selStr
                } else {
                  str = selStr.split('').join(',')
                }
              } else {
                str = sel.join(',')
              }
            } else {
              str = ''
            }
            if (str.length == 0 && !e.icant) {
              noDoCount++
            }
          }
        } else {
          var str = ''
          if (e.exercise_type == 3 && this.checkIsNewSubjective(e)) {
            str = e.user_answer || ''
            if (str.length == 0) {
              noDoCount++
            }
          } else {
            str = e.exercise_type == 2 ? e.select.join(',') : e.select.toString()
            if (e.select.length > 0) {
              str = e.exercise_type == 2 ? e.select.join(',') : e.select.toString()
            } else {
              noDoCount++
            }
          }
        }
      })

      if (noDoCount > 0) {
        const message = '本练习还有' + noDoCount + '道题未做，确认交卷么？'
        Dialog.confirm({
          message: message
        }).then(() => {
          this.submitAll()
        }).catch((err) => {
          console.log(err)
        })
      } else {
        // 直接提交
        this.submitAll()
      }
    },
    clearDownTimer() {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    },
    // 交卷：answer_type=1 时 最后一题交卷
    submitAll() {
      console.log(this.$route.query, 'this.$route.query')
      clearInterval(this.countdownTimer)
      // 提交答案
      const arr = []
      this.doResult.list.forEach(e => {
        var str = ''
        e.select_status = e.select_status ? e.select_status : 1
        if (this.answer_type == 1) {
          if (e.userSelect) {
            const sel = e.userSelect
            if (typeof (sel) === 'string') {
              const selStr = sel.toString()
              if (selStr.indexOf(',' != -1)) {
                str = selStr
              } else {
                str = selStr.split('').join(',')
              }
            } else {
              str = sel.join(',')
            }
          } else {
            str = ''
          }
        } else {
          str = e.exercise_type == 2 ? e.select.join(',') : e.select.toString()
        }
        // 新主观题答案处理
        const is_new = this.checkIsNewSubjective(e)
        if (e.exercise_type == 3 && is_new) {
          str = e.user_answer || ''
          e.select_status = e.icant ? 2 : e.select_status
        }
        const obj = {
          id: e.id,
          option: is_new ? [] : (str === '' ? [] : str.split(',')),
          select_status: e.select_status,
          user_answer: is_new ? str : '',
          is_new: is_new ? 1 : '',
          exercise_type: e.exercise_type
        }
        arr.push(obj)
      })
      const info1 = {
        answer_id: this.answer_id,
        spend: this.allTime,
        answer: JSON.stringify(arr),
        is_app: 0
      }
      submitAnswer(info1).then(res => {
        console.log(res)
        const errNo = res.errNo
        if (errNo == 0) {
          sessionStorage.removeItem('paperLists')
          console.log(this.isWechatMp, 'this.isWechatMp')
          console.log(this.$route.query.pkType, 'this.$route.query.pkType')
          if (this.$route.query.pkType == 1) {
            var url = ''
            if (this.$route.query.pageType == 1) {
              url = `/pages/pkhome/pkhome?lesson_id=${this.lesson_id}`
            } else {
              url = `/pages/pklist/pklist?lesson_id=${this.lesson_id}&tabswitch=${this.$route.query.tabswitch}&chat_id=${this.$route.query.chat_id}`
            }
            this.$wx.miniProgram.redirectTo({
              url: url
            })
            // this.$wx.miniProgram.navigateTo({
            //   url: url
            // })
          } else {
            this.$router.replace({
              path: '/exerciseReport',
              query: {
                answer_id: this.answer_id,
                source_id: this.source_id,
                source_type: this.source_type,
                lesson_id: this.lesson_id,
                class_id: this.class_id,
                schedule_id: this.schedule_id,
                is_exercise_end: 1
              }
            })
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 去登录
    showLogin() {
      const url = `${window.location.origin}/login?redirect=${encodeURIComponent(window.location.href)}`
      window.location.href = url
    },
    // 视频解析
    videoAnalysis(val) {
      if (val.is_video_analysis) {
        if (this.is_play == 1) {
          this.playVideoPop = true
          const video_url = val.url
          this.$nextTick(() => {
            const dom = document.getElementById('video_container')
            var scriptSrc = video_url.replace(/<script [^>]*src=['"]([^'"]+)[^>]*>/gi, function(match, capture) { return capture })
            scriptSrc = scriptSrc.substr(0, scriptSrc.length - 9)
            var scriptTag = document.createElement('script')
            scriptTag.src = scriptSrc
            dom.appendChild(scriptTag)
          })
        } else {
          this.$toast('该解析暂不能观看，请购买课程')
        }
      } else {
        this.$toast('暂无视频解析')
      }
    },
    // 关闭播放
    closePlayVideo() {
      const dom = document.getElementById('video_container')
      dom.removeChild(dom.lastElementChild)
      this.playVideoPop = false
    },
    // 去购买
    buyBtnAction() {
      if (this.hasStrategy) {
        // 展示销售策略
        this.showStrategyView = true
      } else {
        Dialog.confirm({
          title: '提示',
          message: '该课程还未购买哦～',
          confirmButtonText: '去购买'
        })
          .then(() => {
            // on confirm
            this.buyNow(1, this.lesson_id)
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    // 设置是否展示销售策略
    setShowStrategy(e) {
      this.hasStrategy = e
      console.log(e)
    },
    // 取消购买策略弹窗
    colseStrategyView() {
      this.showStrategyView = false
    },
    // 立即购买
    buyNow(type, pro_id) {
      this.showStrategyView = false
      const buy = `${window.location.origin}/pay?product_type=${type}&product_id=${pro_id}`
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openBuyLesson.postMessage(buy)
        } else {
          this.$jsbridge.callHandler(
            'vue_openBuyLesson',
            buy,
            function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        if (this.isWechatMp) {
          const url = `/pages/pay/pay?product_id=${pro_id}&product_type=${type}`
          this.$wx.miniProgram.navigateTo({
            url: url
          })
        } else {
          // 去购买
          window.location.href = buy
        }
      }
    },
    // 返回
    backAction() {
      console.log(this.answer_type + '-------' + this.source_type)
      if ((this.answer_type == 5 || this.answer_type == 1) && this.source_type != 3) {
        // 不是错题
        Dialog.confirm({
          message: '确定要退出，并保存本次练习？'
        })
          .then(() => {
            // on confirm
            this.backFunction()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        // 直接返回
        this.backFunction()
      }
    },
    // 返回的方法
    backFunction() {
      sessionStorage.removeItem('paperLists')
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          this.$jsbridge.callHandler(
            'vue_backApp'
            , '返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        if (this.$route.query.pkType == 1) {
          var url = `/pages/pklist/pklist?lesson_id=${this.lesson_id}&tabswitch=${this.$route.query.tabswitch}&chat_id=${this.$route.query.chat_id}`
          this.$wx.miniProgram.redirectTo({
            url: url
          })
        } else {
          this.$router.go(-1)
        }
      }
    },
    // 删除一道 错题
    clearTopic(item) {
      const info = {
        exercise_id: item.id
      }
      delErrToCorrectExercise(info).then(res => {
        const index = this.doResult.list.findIndex(e => e.id == item.id)
        // 如果当前题数>1时，删除时 testIndex需-1 ，否则的话需要返回上一个页面
        if (this.doResult.list.length > 1) {
          if (this.doResult.list.length > 1 && index == this.doResult.list.length - 1) {
            this.testIndex -= 1
          }
          this.doResult.list.splice(index, 1)
          this.allLength = this.doResult.list.length
        } else {
          this.$router.replace({
            path: '/errorExercise',
            query: {
              category_id: this.category_id,
              category_name: this.category_name
            }
          })
        }
      })
    },
    // 判断是否是错题
    isDoWrong() {
      if (this.source_type == 5 || this.source_type == 6 || this.source_type == 7 || this.source_type == 11 || this.source_type == 12) {
        return true
      }
      return false
    },
    /** *** 帮友讨论相关方法 *****/
    // 获取问答列表
    getTopicDatas(item) {
      const params = {
        lesson_id: this.lesson_id,
        section_id: item.id,
        type: 6, // 写死类型
        page: 1,
        limit: 100
      }
      QaAll(params).then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          const list = result.list || []
          item.topicList = list
        }
      })
    },
    // 发送提问
    sendTopic(item) {
      console.log('send ')
      const text = item.topicInputText || ''
      if (text.length > 0) {
        const info = {
          lesson_id: this.lesson_id,
          section_id: item.id,
          type: 6, // 写死类型
          content: text
        }
        saveQa(info).then(res => {
          if (res.errNo == 0) {
            item.topicInputText = ''
            this.getTopicDatas(item)
            this.$toast('提问成功')
          } else {
            this.$toast(res.msg)
          }
        })
      } else {
        this.$toast('请填写问题内容')
      }
    },
    // 纠错出弹框
    toCorrect(item) {
      console.log(item)
      this.inputCorrect = ''
      this.correctId = item.id
      this.showCorrect = true
    },
    // 获取纠错来源
    getRecorrectSource() {
      // source: 来源： 1注考帮app 2注考帮小程序 3注考帮h5 4注考帮PC 、 5筑龙app 6筑龙小程序 7筑龙h5 8筑龙pc 9商城pc 10商城h5
      var source = '10'
      return source
    },
    // 提交
    commitCorrect() {
      console.log(this.inputCorrect)
      const input = this.inputCorrect
      if (input) {
        const info = {
          id: this.correctId,
          description: input,
          source: this.getRecorrectSource()
        }
        this.showLoading = true
        errorFeedback(info).then(res => {
          this.showLoading = false
          if (res.errNo === 0) {
            this.$toast('提交成功')
            this.inputCorrect = ''
            this.correctId = ''
            this.showCorrect = false
          } else {
            this.$toast(res.msg || '提交失败')
          }
        }).catch(() => {
          this.showLoading = false
        })
      } else {
        this.$toast('请输入问题描述')
      }
    },
     /**  新版智能解析 主观题  **/
    // 判断是否是新主观题
    checkIsNewSubjective(val) {
      if (val.exercise_type == 3) {
        const answer_type = val.answer_type || ''
        if (answer_type && answer_type.length > 0 && answer_type != 0) {
          return true
        }
      }
      return false
    },
    // 获取token
    getAiEnToken() {
      getAiEnToken().then((res) => {
        if (res.errNo == 0) {
          var data = JSON.parse(res.result)
          this.aiConfig.appkey = data.appkey || ''
          this.aiConfig.token = data.token || ''
        }
      })
    },
    // 回调，结果：成功
    analysisSuccess(text, item) {
      item.user_answer = text || ''
      if (item.user_answer.length > 0) {
        item.checkBtnState = false
      } else {
        item.checkBtnState = true
      }
      console.log('答案变化 = ', item)
    },
    // 回调，结果：失败
    analysisError(type, tips, item) {
      if (type == 1) {
        console.log('图片 识别出错 = ', tips)
      } else {
        console.log('语音 识别出错 = ', tips)
      }
      this.$toast(tips)
    }
  }
}
</script>

<style lang="scss" scoped>
.green_bg{
  border:1px solid #c9f7cd;
  border-radius: 6px;
  background-image: url('https://newoss.zhulong.com/book/202211/15/29/1615291rwuyazsrerzqsvj.png');
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: bottom right;
  background-color: #edfff1;
}
/deep/.van-radio__label{
  flex: 1;
  div{
    width: 100%;
  }
}
/deep/.van-checkbox__label{
  flex: 1;
  div{
    width: 100%;
  }
}
$bottomH: 120px;

.body {
  width: 100%;
  text-align: left;
  background-color: #fff;
}
.topHead {
  position: relative;
}
.timerBox {
  padding: 0px 10px;
  background-color: #fff;
  width: calc(100% - 20px);
  height: 100px;
  border-bottom: 2px solid #eee;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  z-index: 2;
  .backIcon {
    margin: auto 0;
    width: 50px;
    height: 50px;
  }
  p {
    flex: 1;
    margin: 10px 10px;
    font-family: PingFangSC-Regular;
    color: #333;
    font-size: 36px;
    text-align: center;
  }
  .topCard {
    margin: auto 10px;
    padding: 5px;
    border-radius: 8px;
    background-color: #ee2e2e;
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 400;
  }
  .counts {
    margin: auto 10px;
    color: #333;
    font-size: 28px;
  }
}
.main {
  width: 100%;
  padding-top: 100px;
  padding-bottom: $bottomH;
  background-color: #fff;
  min-height:calc(100vh - 260px);
}
.item {
  width: 100%;
  // background-color: #fff;
  padding-bottom:80px;
  .itemTop {
    width: calc(100% - 60px);
    padding: 20px 30px 20px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    .itemTitle2{
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #333;
      font-weight: 600;
      line-height: 60px;
      word-break: break-all;
    }
    .itemTitle {
      font-family: PingFangSC-Regular;
      font-size: 36px;
      color: #333;
      word-break: break-all;
      margin-bottom: 20px;
      // width: 100%;
      // display: flex;
      // flex-wrap: wrap; // 强制换行
      // justify-content: flex-start; //所有元素右对齐

      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      .titleBox{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .redSpan {
        font-size: 30px;
        color: #ee2e2e;
        padding: 2px 4px;
        // margin-right: 5px;
        text-align: center;
        // border-radius: 8px;
        // background-color: #ee2e2e;
        position:relative;
      }
      .titleBoxRight {
        display: flex;
        align-items: center;
        .delete {
          width: 40px;
          margin-right: 10px;
        }
      }
      .left_bor,.right_bor{
        position:absolute;
        display: inline-block;
        width:8px;
        height:16px;
        border:2px solid #ee2e2e;
      }
      .left_bor{
        top: 8px;
        left: -6px;
        border-right: none;
        border-bottom: none;
      }
      .right_bor{
        bottom: 6px;
        right: -1px;
        border-left: none;
        border-top: none;
      }
      .itemId{
        background-color: #fff;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        line-height: 50px;
        color: #cacaca;
        letter-spacing: 0;
        font-weight: 400;
        // margin-left:10px;
      }
      .counts{
        font-size: 30px;
      }
    }
  }
  .itemOpiton {
    padding: 0px 30px;
    .oneOption {
      font-family: PingFangSC-Regular;
      color: #333;
      font-size: 32px !important;
      line-height: 50px;
      /deep/ img {
        max-width: 100% !important;
      }
    }
    .solution_icon {
      height: 56px;
      width: 56px;
      // margin-top: -10px
    }
    .check{
      text-align:center;
      height: 56px;
      width: 56px;
      line-height:56px;
      color:#333;
      font-size:32px;
    }
    .check.checkActive{
      color:#fff;
    }
    /deep/ .van-radio__label--disabled {
      color: #333333;
    }
    /deep/ .van-checkbox__label--disabled {
      color: #333333;
    }
  }
  .icant {
    // margin-top: 30px;
    padding-bottom: 40px;
    width: 100%;
    height: 80px;
    text-align: center;
    span {
      margin-top: 10px;
      width: 240px;
      height: 60px;
      display: inline-block;
      border: 2px solid rgba(238, 46, 46, 1);
      border-radius: 30px;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #ee2e2e;
      font-weight: 400;
      line-height: 60px;
    }
  }
  .div_answer {
    padding: 0px 30px 0px;
    width: calc(100% - 60px);
    text-align: left;
    .answerBox {
      .answerBoxTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 50px;
        .answer_title{
          margin-bottom:20px;
          font-size:32px;
          font-weight: 600;
          color: #333;
        }
        .answer_jc {
          display: flex;
          align-items: center;
          font-size: 26px;
          color: #333;
          margin-bottom:20px;
          img {
            margin: 0 5px;
            width: 30px;
            height: 30px;
            display: block;
          }
        }
      }
     .answer_res{
      display: flex;
      justify-content: space-between;
     }
      padding: 25px 0;
      .p_answer {
        width: 45%;
        height: 120px;
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        line-height: 50px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
        // border:1px solid #cccc;
        background: url('https://newoss.zhulong.com/book/202211/15/29/1615291rwuyazsrerzqsvj.png');
        background-size: contain;
        border-radius: 8px;
      }
      .empty_answer{
        background: url('https://newoss.zhulong.com/book/202211/15/37/161637ujr2nno0zhqsy5av.png') no-repeat;
         background-size: contain;
      }
      .error_answer{
        background: url('https://newoss.zhulong.com/book/202211/15/37/161637ujr2nno0zhqsy5av.png') no-repeat;
         background-size: contain;
      }
      .right_answer{
        background: url('https://newoss.zhulong.com/book/202211/15/29/1615291rwuyazsrerzqsvj.png') no-repeat;
        background-size: contain;
      }
      .error_answer1{
        background: url('https://newoss.zhulong.com/book/202211/15/37/161637ujr2nno0zhqsy5av.png') no-repeat;
        background-position: right bottom;
        background-color: rgb(255, 238, 238);
      }
      .right_answer1{
        background: url('https://newoss.zhulong.com/book/202211/15/29/1615291rwuyazsrerzqsvj.png') no-repeat;
        background-position: right bottom;
        background-color: rgb(237, 255, 241);
      }
      .span_tag_is_true {
        margin-left: 5px;
        padding: 2px 7px;
        color: #fff;
        border-radius: 8px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        font-weight: 400;
      }
      .red {
        background: #ee2e2e;
      }
      .green {
        background: #54d32a;
      }
      .green_font{
        color:#54d32a;
        font-weight:600;
      }
      .red_font{
        color: #ee2e2e;
        font-weight:600;
      }
      .new_answer_res {
        display: flex;
        flex-direction: column;
        .new_answer {
          font-family: PingFangSC-Regular;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          line-height: 50px;
          padding: 15px;
          span {
            font-weight: 600;
          }
        }
        .mgtop {
          margin-top: 10px;
        }
      }
    }
    .vLine {
      margin-left: -30px;
      width: calc(100% + 60px);
      height: 20px;
      background-color: #eeeeee;
    }
    .analysisBox {
      // height: auto;
      margin-top: 30px;
      padding-bottom: 20px;
      .jx_title {
        border-left: #ee2e2e 4px solid;
        padding-left: 14px;
        height: 35px;
        font-size: 32px;
        font-weight: 500;
        color: #333;
        line-height: 40px;
        text-align: left;
      }
      .jx_content {
        margin-top: 16px;
        font-size: 32px !important;
        font-weight: 400;
        color: #333;
        line-height: 42px;
        text-align: left;
        /deep/img {
          max-width: 100% !important;
        }
      }
      .noBuyBox {
        margin-top: 30px;
        width: calc(100% - 140px);
        padding: 0 70px;
        text-align: center;
        .buyInfo {
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #333333;
          text-align: center;
          font-weight: 500;
        }
        .buyBtn {
          margin-top: 25px;
          width: 360px;
          height: 80px;
          display: inline-block;
          background-color: #ee2e2e;
          border-radius: 8px;
          font-family: PingFangSC-Medium;
          line-height: 80px;
          font-size: 36px;
          color: #ffffff;
          font-weight: 500;
        }
      }
    }
  }
}

// 讨论
.topicsBox {
  padding: 30px 0;
  width: 100%;
  // background-color: aqua;
  // height: 40px;
  .inputBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .input_ {
      margin-left: 15px;
      width: calc(100% - 140px);
      padding: 10px 10px;
      border-radius: 12px;
      border: 2px solid #eee;
    }
    .sendBtn {
      margin-left: 20px;
      display: inline-block;
      width: 100px;
      height: 60px;
      line-height: 60px;
      background-color: #ee2e2e;
      color: #fff;
      font-size: 28px;
      text-align: center;
      border-radius: 12px;
    }
  }
  .topicLists {
    margin-top: 30px;
    width: 100%;
    .topicItem {
      padding: 20px 0;
      width: 100%;
      border-bottom: 2px solid #eee;
      display: flex;
      flex-direction: column;
      .mainItem {
        display: flex;
      }
      .subBox {
      }
      .subItem {
        padding-left: 100px;
        width: calc(100% - 100px);
        display: flex;
        margin-top: 20px;
      }
      .imgBox {
        width: 80px;
        height: 80px;
        .avatar {
          border-radius: 40px;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .topicInfo {
        margin-left: 20px;
        width: calc(100% - 100px);
        .topInfo {
          font-size: 24px;
          color: #333;
          .time1 {
            margin-left: 20px;
            color: #999;
          }
        }
        .redT {
          color: #ee2e2e;
        }
        .grayT {
          color: #999;
        }
        .content {
          margin-top: 10px;
          font-size: 24px;
          color: #999;
        }
        .time2 {
          margin-top: 10px;
          font-size: 24px;
          color: #999;
        }
      }
    }
  }
}

.videoBtnBox {
  margin-top: 40px;
  position: relative;
  .playItems {
    display: flex;
    align-items: center;
    img {
      display: block;
      width: 60px;
      height: 60px;
    }
    span {
      margin-left: 10px;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #ee2e2e;
      font-weight: 400;
    }
  }
  .maskV {
    position: absolute;
    width: 100%;
    height: 60px;
    top: 0;
    background-color: rgba(255, 255, 255, 0.5);
  }
}
.footer {
  background-color: #fff;
  // border-top: 1px solid #ddd;
  box-shadow: 0px -5px 10px -5px #e6e6e6;
  width: 100%;
  height: $bottomH;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  z-index: 100;
  &>div{
    width:100%;
  }
  .prev_img,.next_img{
    width:32px;
  }
  .answer_img{
    width:100px;
    margin-top:-20px;
  }
  .itemId {
    background-color: #fff;
    position: absolute;
    right: 20px;
    top: -60px;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    line-height: 50px;
    color: #cacaca;
    letter-spacing: 0;
    font-weight: 400;
  }
  .menuBg1 {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .normaleBtn {
      width: 25%;
      // height: 80px;
      margin-top: 10px;
      margin-left: 20px;
      margin-right: 10px;
      display: inline-block;
      background-color: #fff;
      border-radius: 4px;
      // border: 1px solid #ee2e2e;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #333333;
      font-weight: 400;
      text-align: center;
      line-height: 80px;
      display: flex;
      align-items:center;
      justify-content: center;
    }
    .btnGray {
      // border: 1px solid rgba(219, 219, 219, 1);
      color: rgba(219, 219, 219, 1);
    }
    .redBgBtn {
      width: 50%;
      // height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 10px;
      display: inline-block;
      // background-color: #ee2e2e;
      border-radius: 4px;
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #333;
      font-weight: 400;
      text-align: center;
      // line-height: 80px;
      display: flex;
      flex-direction: column;
      align-items:center;
      justify-content: center;
    }
    .grayLineBtn {
      width: 50%;
      // height: 82px;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 10px;
      display: inline-block;
      background-color: #fff;
      border-radius: 4px;
      // border: 1px solid rgba(219, 219, 219, 1);
      font-family: PingFangSC-Regular;
      font-size: 28px;
      color: #999999;
      font-weight: 400;
      text-align: center;
      // line-height: 82px;
      display: flex;
      flex-direction: column;
      align-items:center;
      justify-content: center;
    }
    .grayLineBtn1 {
      width: 100%;
      // height: 82px;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 20px;
      display: inline-block;
      background-color: #fff;
      border-radius: 4px;
      // border: 1px solid rgba(219, 219, 219, 1);
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #dbdbdb;
      font-weight: 400;
      text-align: center;
      line-height: 82px;
      display: flex;
      align-items:center;
      justify-content: center;
    }
    .outerBox{
      width:25%;
      margin-top: 10px;
      margin-right: 20px;
    }
    .redLineBtn {
      width: 100%;
      // height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 20px;
      display: inline-block;
      background-color: #fff;
      border-radius: 4px;
      // border: 1px solid #ee2e2e;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #333333;
      font-weight: 400;
      text-align: center;
      line-height: 80px;
      display: flex;
      align-items:center;
      justify-content: center;
    }
  }
  .menuBg2 {
    width: 100%;
    height: 100px;
    padding: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    text-align: center;
    .counts {
      display: inline-block;
      width: 33%;
      color: #333;
      font-size: 32px;
      height: 60px;
      line-height: 60px;
      border-left: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    .normaleBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 33%;
      height: 60px;
      line-height: 60px;
      font-family: PingFangSC-Regular;
      font-size: 32px;
      color: #333333;
      font-weight: 400;
    }
    .btnGray {
      color: rgba(219, 219, 219, 1);
    }
    .left_icon {
      margin-right: 10px;
    }
    .right_icon {
      margin-left: 10px;
    }
  }
}
.van-radio,
.van-checkbox {
  padding: 25px 0;
  // border-bottom: 1px solid #eeee;
  font-size: 16px;
  min-height:56px;
  line-height: 56px;
}
.van-radio{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/deep/ .van-radio__icon,/deep/ .van-checkbox__icon{
  margin-top:0px;
  height: 56px;
  position:relative;
  .check{
    position:absolute;
    left: 0px;
    top: 0px;
  }
}
.next_text{
  margin-right: 10px;
}
.prev_text{
  margin-left: 10px;
}

.name {
  /deep/ p {
    display: inline !important;
    line-height: 64px;
  }
  /deep/ img {
    max-width: 100% !important;
  }
}
.swiper-container{
  height: calc(100vh - 220px) !important;
  // overflow-y: scroll !important;
}
.topic_item{
  width: 100%;
  height: calc(100vh - 220px) !important;
  overflow-y: scroll !important;
}

/deep/ .slider-container{
  white-space:normal;
}
.slider-item{
  height: 100%;
  text-align: left;
}
/deep/ .slider-wrapper{
  align-items: flex-start;
}
.input_body {
  margin: 0 50px;
  width: calc(100% - 100px);
  height: 100%;
  position: relative;
  .input_box {
    padding: 30px;
    width: calc(100% - 60px);
    background-color: #fff;
    border-radius: 16px;
    min-height: 300px;
    .t_title {
      text-align: center;
      font-size: 28px;
      color: #333;
      font-weight: 700;
    }
    .title_tip {
      margin-top: 10px;
      text-align: center;
      font-size: 24px;
      color: #ee2e2e;
    }
    .input_field {
      margin-top: 10px;
      padding: 15px 15px;
      height: 200px;
      border-radius: 12px;
      border: 1px solid #ddd;
      font-size: 24px;
      line-height: 34px;
    }
    .bot_menu {
      margin-top: 25px;
      text-align: center;
      span {
        display: inline-block;
        width: 120px;
        height: 50px;
        background-color: #ee2e2e;
        color: #fff;
        line-height: 50px;
        border-radius: 10px;
      }
    }
  }
}
</style>
